import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { RentalMovementImportModel } from 'src/app/models/imports/rental-movements-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RentalMovementsService {

  constructor(private _httpClient: HttpClient) { }

  downloadGuideImportRentalMovement(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.rentalMovements.DownloadGuideImportRentalMovement}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalMovements.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  importRentalMovement(rentalMovementImports: Array<RentalMovementImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.rentalMovements.ImportRentalMovements}`, rentalMovementImports);
  }
}
